import "./CardsTextBlock.scss";
import {
  BlockTop,
  GridPresetOneHalf,
  GridPresetWideContent,
  GridRow,
  OptimizelyEditProperty,
} from "/App.Components";
import CardItemBlock from "/Components/Blocks/CardItemBlock/CardItemBlock";
import { RowSpacing } from "/Components/Layout/GridRow/GridRow";
import { CardsTextBlockProps } from "/Models/Generated/CardsTextBlockProps";

const CardsTextBlock = ({
  blockTop,
  cards,
  cardsPropertyName,
  theme,
}: CardsTextBlockProps) => (
  <div className="cards-text-block-norad">
    <GridRow>
      <GridPresetWideContent>
        <BlockTop {...blockTop} />
      </GridPresetWideContent>
    </GridRow>
    <OptimizelyEditProperty propertyName={cardsPropertyName} clientRender>
      {(cards?.length ?? 0) > 0 && (
        <GridRow rowSpacing={RowSpacing.textCards}>
          {cards.map((card, idx) => (
            <GridPresetOneHalf key={idx} displayFlex>
              <CardItemBlock {...card} theme={theme} />
            </GridPresetOneHalf>
          ))}
        </GridRow>
      )}
    </OptimizelyEditProperty>
  </div>
);

export default CardsTextBlock;
